/**
 * The IN-PAGE BAR: one surface stored under three keys.
 *
 * Hero bar, in-content line and end-of-page banner rendered the same search
 * stack (Brian, 2026-10-25: "they all seem like the same thing"), so they are
 * one placement now — a bar a site pastes into its pages, as many times as it
 * likes. The three keys stay because both ends of the wire depend on them:
 * stored designs and scope rules name them, cached bh.js bundles in the field
 * read them, and their anchor divs (`-hero`, `-line`, `-cta`) are on live
 * pages. Every read and write keeps the three identical (`syncInPageBar`), so
 * the three divs are aliases of each other.
 *
 * `hero_bar` is the canonical key: the dashboard edits it and the sync copies.
 * The sync itself lives in ./schema.ts (`syncInPageBar`, and the read-side
 * merge inside `upgradeWidgetDesign`).
 *
 * Pure module (no zod) so the widget snippet (bh.js) can import it — the
 * bundle-integrity gate in widget/build.ts bans zod there.
 */
export const IN_PAGE_BAR_KEYS = ["hero_bar", "in_content_line", "end_of_page_banner"] as const;
export type InPageBarKey = (typeof IN_PAGE_BAR_KEYS)[number];
export const IN_PAGE_BAR = "hero_bar" satisfies InPageBarKey;
